import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import classNames from 'classnames';

import { Consulting } from '@layouts/Consulting';
import {
	Awards,
	DescriptionWithAnimation,
	DescriptionWithImage,
	Reviews,
} from '@components';
import { Header, Sensors, SystemIntergrations } from './components';
import TranscribeCaseStudyImage from '@static/images/figures/transcribe-case-study.webp';
import softwareIntegrationAnimationData from '@images/animations/systemIntegrations.json';
import { PageUrls } from '@utils/constants/PageUrls';
import useReviewsQuery from '@utils/hooks/useReviewsQuery';

import * as styles from './Integrations.module.scss';

export const Integrations: React.FC = () => {
	const { directus } = useStaticQuery(graphql`
		query IntegrationsReviews {
			directus {
				PageReviews(filter: { pageName: { _contains: "integrations" } }) {
					Reviews {
						Reviews_id {
							quote
							reviewerName
							reviewerPosition
							link
							title
							logo {
								id
								imageFile {
									extension
									publicURL
									childImageSharp {
										gatsbyImageData
									}
								}
							}
						}
					}
				}
			}
		}
	`);
	const reviews = useReviewsQuery(directus);

	return (
		<div className="z-99 relative overflow-hidden">
			<Header />
			<DescriptionWithAnimation
				className="gray-bg"
				animationOnTheRight
				animationData={softwareIntegrationAnimationData}
				disableContentPadding
			>
				<h2 className="font-size-md mb-2">System integrations</h2>
				<p className="mb-4 font-size-sm line-height-26">
					The topic is vast, and one of the most accessible integration
					processes is that of open source software. Solutions containing a
					particular interface - API - are also relatively programmer-friendly.
					However, nothing stands in the way of performing programming services
					in other conditions. The vast majority of systems can be integrated
					with other units.
				</p>
				<h2 className="font-size-md mb-2 mt-5">
					Integration of external tools
				</h2>
				<p className="mb-4 font-size-sm line-height-26">
					This solution lets for connection between ready-made applications with
					an external system. It is necessary when the application wants to log
					into using Facebook, Instagram, and some ready-made account to use the
					authorization of an external service. This tool so you can use it as
					the customer wants. This also applies to payment services, data feeds,
					control systems, etc.
				</p>
			</DescriptionWithAnimation>
			<DescriptionWithImage
				className={classNames(styles.typography, 'white-bg')}
				imageClassName={styles.image}
				image={TranscribeCaseStudyImage}
			>
				<p className="font-size-small-title mb-3 font-600">
					Transcription and annotation platform
				</p>
				<p className="font-size-sm mb-4">
					Transcribe is a platform to make transcribers' work easier. All that
					was possible with the use of ASR solutions.
				</p>
				<Link
					to={PageUrls.TRANSCRIBE_CASE_STUDY}
					className="bttn bttn-orange-border link"
				>
					See full case study
				</Link>
			</DescriptionWithImage>
			<SystemIntergrations />
			<Sensors />
			{!!reviews.length && (
				<Reviews
					title="Our client says"
					reviews={reviews}
					maxWidth="1300px"
					titleClass="font-size-medium-title"
				/>
			)}
			<Awards className="white-bg" />
			<Consulting />
		</div>
	);
};
